import React from 'react';
import { FormattedMessage } from 'react-intl';
import IndexContainer from 'components/place/index_container';
import BreadcrumbContainer from 'components/breadcrumb_container';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import Container from 'components/layout/container';

const Places = () => {
  return (
    <PaginateProvider>
      <Container>
        <BreadcrumbContainer>
          <BreadCrumbTypography>
            <FormattedMessage id="breadcrumb.place.index" />
          </BreadCrumbTypography>
        </BreadcrumbContainer>
        <IndexContainer />
      </Container>
    </PaginateProvider>
  );
};

export default Places;
